<div class="selector-wrapper">
  @if(showDialog()) {
    <app-search-view-selector
      [selectorContainer]="selectorContainer()"
      (modalClosed)="dialogRef.close([])"
    />
  }
</div>
